var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleteTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 6,
    fill: "#C5D773"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8021 56.8737H30.963C32.8204 56.8729 34.6757 56.8738 36.5305 56.8747C39.1267 56.8759 41.7219 56.8772 44.3204 56.8737C47.2257 56.8678 48.915 55.2078 48.915 52.3258C48.9229 43.4567 48.9229 34.5862 48.915 25.7144C48.9111 22.7617 47.2355 21.0879 44.289 21.0879C35.4469 21.0775 26.6075 21.0775 17.7706 21.0879C14.7731 21.0919 13.125 22.7676 13.125 25.7851V52.2001C13.127 55.2137 14.7868 56.8737 17.8021 56.8737ZM20.76 52.8983H30.9973C32.4424 52.8977 33.8858 52.8984 35.3289 52.8991C37.348 52.9001 39.3665 52.901 41.3875 52.8983C43.6474 52.8938 44.9614 51.6026 44.9614 49.3611C44.9675 42.4629 44.9675 35.5636 44.9614 28.6633C44.9584 26.3668 43.655 25.0649 41.3631 25.0649C34.4852 25.0568 27.6093 25.0568 20.7355 25.0649C18.4039 25.068 17.1219 26.3713 17.1219 28.7183V49.2633C17.1234 51.6072 18.4145 52.8983 20.76 52.8983Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8731 40.9661C56.8782 33.2315 56.8773 25.4959 56.8705 17.7593C56.8665 14.8066 55.191 13.1329 52.2445 13.1329C43.8357 13.1229 35.4294 13.1224 27.0254 13.1314V17.3958C27.4997 17.2076 28.0565 17.1105 28.6909 17.1096C35.5647 17.1015 42.4405 17.1015 49.3184 17.1096C51.6104 17.1096 52.9137 18.4114 52.9168 20.708C52.9228 27.4616 52.9229 34.2143 52.9172 40.9661H56.8731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteTask);
export default __webpack_public_path__ + "static/media/completeTask.7af7b069f89a754f5923ed9424b64b07.svg";
export { ForwardRef as ReactComponent };